import { useState } from 'react';
import type { TurnStatusRow } from './turn-status';
import { formatElapsed, useNow } from './use-elapsed';

export function TurnStatusLine({
  rows,
  thinkingContent,
}: {
  rows: TurnStatusRow[];
  thinkingContent?: string;
}) {
  const [open, setOpen] = useState(false);
  const now = useNow(rows.some((row) => row.activeSince));
  if (rows.length === 0 && !thinkingContent) return null;
  return (
    <div data-testid="turn-status-line" className="space-y-1 text-body text-muted-foreground">
      <ol className="space-y-0.5">
        {rows.map((row, index) => (
          <li
            key={`${row.personaName}-${row.phrase}-${index}`}
            data-testid="turn-status-row"
            data-active={row.activeSince ? 'true' : undefined}
          >
            {row.personaName} · {row.phrase}
            {row.detail ? ` ${row.detail}` : null}
            {row.fanout ? (
              <span data-testid="turn-status-fanout">
                {' '}
                · {row.fanout.done} of {row.fanout.total} done
              </span>
            ) : null}
            {row.activeSince ? (
              <span data-testid="turn-status-elapsed" className="tabular-nums">
                {' '}
                · {formatElapsed(now - new Date(row.activeSince).getTime())}
              </span>
            ) : null}
          </li>
        ))}
      </ol>
      {thinkingContent ? (
        <div>
          <button
            type="button"
            data-testid="view-reasoning"
            className="text-caption underline"
            onClick={() => setOpen((v) => !v)}
          >
            View reasoning
          </button>
          {open ? (
            <pre data-testid="thinking-content" className="mt-1 whitespace-pre-wrap text-caption">
              {thinkingContent}
            </pre>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
